var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pravo-sirsi"},[_c('div',{staticClass:"pravo-sirsi__welcome"},[_c('ButtonOverview'),_c('Banner'),_c('Texts'),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pravo-sirsi__welcome__version"},[_c('div',{staticClass:"pravo-sirsi__welcome__version__number"},[_vm._v("version 1.6.0")])])
}]

export { render, staticRenderFns }